import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api/client";
import { qk } from "../../api/queries";
import type { Project } from "../../api/types";
import { useDialogs } from "../../components/Dialogs";
import { ProjectForm } from "../../components/ProjectForm";

export function GeneralSettings({ project }: { project: Project }) {
  const qc = useQueryClient();
  const { toast } = useDialogs();
  const save = useMutation({
    meta: { inlineError: true },
    mutationFn: (p: Parameters<typeof api.patchProject>[1]) => api.patchProject(project.id, p),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.projects });
      qc.invalidateQueries({ queryKey: qk.project(project.id) });
      toast("Project saved", "info");
    },
  });
  return (
    <ProjectForm
      key={project.id}
      initial={project}
      submitLabel="Save changes"
      onSubmit={(p) => save.mutate(p)}
      pending={save.isPending}
      error={save.error}
    />
  );
}
